export default __webpack_public_path__ + "static/media/third.035f1be2.mp4";